import React from "react";

import PageHeading from "2g-page-heading";

import { ZdrojeTabsContent } from "b2b/components/zdroje-tabs/ZdrojeTabsContent";

const data = require("b2b-devel/zdroj/typyzdroje.json");

// eslint-disable-next-line react/prop-types
const Content = ({ indexActive, data }) => (
  <div>
    <div>index: {indexActive}</div>
    <div>data: {JSON.stringify(data)}</div>
  </div>
);

export function ZdrojeTabsContentExample() {
  return (
    <>
      <PageHeading>ZdrojeTabsContent</PageHeading>
      <div data-testid="loaded">
        <ZdrojeTabsContent contentRenderer={Content} typyZdroju={data} />
      </div>
      <PageHeading>ZdrojeTabsContent - loading</PageHeading>
      <div data-testid="loading">
        <ZdrojeTabsContent
          contentRenderer={Content}
          loading
          typyZdroju={data}
        />
      </div>
    </>
  );
}

ZdrojeTabsContentExample.propTypes = {};

export default React.memo(ZdrojeTabsContentExample);
